<template lang="pug">
app-page-layout
  div.detail-container.abs-fit
  
    a-card.mt1(:loading="loading" title="产品详情" hoverable)
      app-card-base-info(:baseInfo="model" :fields="fields" :colspans="{ sm: 12 }" style="padding: 0;")
</template>

<script>
// import RecordDetail from '../my-tasks/Components/Records/RecordDetail';

import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'detailXXX',
  components: {
    // RecordDetail,
  },
  data() {
    return {
      fields: [
        { name: 'name', label: '产品名称' },
        { name: 'code', label: '产品代码' },
        { name: 'categoryName', label: '产品类别' },
        { name: 'parts', label: '分件数' },
        { name: 'model', label: '产品型号' },
        { name: 'specification', label: '产品规格' },
        { name: 'brandName', label: '产品品牌' },
        {
          name: 'enabled',
          label: '是否上线',
          render(h, m, v) {
            return (
              <app-enabled-display
                enabled={v}
                trueLabel="上线"
                falseLabel="下线"
              />
            );
          },
        },
        { name: 'createNickname', label: '创建人' },
        { name: 'createTime', label: '创建时间' },
        { name: 'editNickname', label: '修改人' },
        { name: 'editTime', label: '修改时间' },

        // { name: 'remark', label: '备注' },
      ],
      tableColumns: [
        { uid: 'name', dataIndex: 'name', title: '品牌名称', width: '200px' },
      ],
      //
      loading: false,
      model: {},
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    id() {
      const id = this.$route.params.id;
      return id;
    },
  },
  created() {
    this.loadModel();
  },
  methods: {
    loadModel() {
      this.loading = true;
      this.$restful(`GET:/prj/products/${this.id}`)
        .then((res) => {
          this.model = res || {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      this.$back();
    },
  },
};
</script>
<style lang="less" scoped>
.detail-container {
  height: 100%;
  padding: 20px;
  .detail-content {
    height: 100%;
    background-color: #fff;
    overflow: auto;
  }
}
</style>
